abstract class Module {

	protected systemName: string = 'System';

	protected constructor(name: string) {
		this.systemName = name;

		console.log(name, 'Constructor');
	}

	public init() {
		this.prepareView();

		this.msg('view init done');
	}

	protected msg(msg: string) {
		console.log(this.systemName, msg);
	}

	protected errorMsg(msg: string) {
		console.error(this.systemName, msg);
	}

	prepareView() {
		// this.setConfig();
		this.startup();
		this.bind();
	}

	abstract startup(): void;
	abstract bind(): void;
	// abstract setConfig(): void;
}

export interface ModuleConfigInterface {
	cssId: {
		[key: string]: string;
	}
}


export default Module;